/**
 * Customer list views (`custViews.*`): cards, grouping, card sorting. Merged through `extra.ts`;
 * `custViewsEn` is typed against `custViewsPl`, so a missing key is a compile error.
 */
type Shape<T> = { [K in keyof T]: T[K] extends string ? string : Shape<T[K]> };

export const custViewsPl = {
  viewLabel: 'Widok klientów',
  cards: 'Karty',
  groupBy: 'Grupuj wg',
  groupByNone: 'Bez grupowania',
  groups: { status: 'Status', customerClass: 'Klasa', owner: 'Opiekun', segment: 'Segment', city: 'Miasto' },
  none: { status: 'Brak statusu', customerClass: 'Brak klasy', owner: 'Brak opiekuna', segment: 'Brak segmentu', city: 'Brak miasta' },
  expandAll: 'Rozwiń wszystkie',
  collapseAll: 'Zwiń wszystkie',
  showMore: 'Pokaż więcej (pozostało {count})',
  groupCount: '{count} klientów',
  groupsEmpty: 'Brak grup do wyświetlenia',
  groupLoadError: 'Nie udało się pobrać klientów tej grupy.',
  groupsLoadError: 'Nie udało się pobrać grup.',
  groupEmpty: 'Brak klientów w tej grupie.',
  sortLabel: 'Sortuj karty',
  sortOrderAsc: 'Rosnąco',
  sortOrderDesc: 'Malejąco',
  sortFields: { name: 'Nazwa', city: 'Miasto', lastOrderAt: 'Ostatnie zamówienie', nextContactAt: 'Następny kontakt', updatedAt: 'Ostatnia zmiana' },
  sortDefault: 'Domyślnie',
  lastOrder: 'Ostatnie zamówienie',
  nextContact: 'Następny kontakt',
  noOrder: 'brak zamówień',
  noContact: 'nie zaplanowano',
  daysAgo: '{count} dni temu',
  openCustomer: 'Otwórz kartę klienta: {name}',
};

export const custViewsEn: Shape<typeof custViewsPl> = {
  viewLabel: 'Customer view',
  cards: 'Cards',
  groupBy: 'Group by',
  groupByNone: 'No grouping',
  groups: { status: 'Status', customerClass: 'Class', owner: 'Owner', segment: 'Segment', city: 'City' },
  none: { status: 'No status', customerClass: 'No class', owner: 'No owner', segment: 'No segment', city: 'No city' },
  expandAll: 'Expand all',
  collapseAll: 'Collapse all',
  showMore: 'Show more ({count} left)',
  groupCount: '{count} customers',
  groupsEmpty: 'No groups to show',
  groupLoadError: 'Could not load the customers of this group.',
  groupsLoadError: 'Could not load the groups.',
  groupEmpty: 'No customers in this group.',
  sortLabel: 'Sort cards',
  sortOrderAsc: 'Ascending',
  sortOrderDesc: 'Descending',
  sortFields: { name: 'Name', city: 'City', lastOrderAt: 'Last order', nextContactAt: 'Next contact', updatedAt: 'Last change' },
  sortDefault: 'Default',
  lastOrder: 'Last order',
  nextContact: 'Next contact',
  noOrder: 'no orders',
  noContact: 'not scheduled',
  daysAgo: '{count} days ago',
  openCustomer: 'Open customer card: {name}',
};
